var MarkerClusterer = require("@google/markerclustererplus/");
var Mustache = require('mustache');
var VetSearchResultPopup;

(function ($) {
    'use strict';

    /** @var array */
    window.dataLayer = window.dataLayer || [];

    /** @var string */
    var template = $('#VetSearchResultPopupTemplate').html();

    var isOpen = function (dateIntervals) {
        if (Array.isArray(dateIntervals)) {
            for (var i = 0; i < dateIntervals.length; i++) {
                let dateInterval = dateIntervals[i];
                let dateIntervalParts = dateInterval.slice(1, -1).split(' TO ');
                let now = new Date();
                let from = new Date(dateIntervalParts[0]);
                let to = new Date(dateIntervalParts[1]);
                if (now > from && now < to) {
                    return true;
                }
            }
        }
        return false;
    };

    /**
     * Returns the Popup class.
     *
     * Unfortunately, the Popup class can only be defined after
     * google.maps.OverlayView is defined, when the Maps API is loaded.
     * This function should be called by initMap.
     */
    function createPopupClass() {
        /**
        * A customized popup on the map.
        * @param {!google.maps.Marker} marker
        * @constructor
        * @extends {google.maps.OverlayView}
        */
        function Popup(marker) {
            this.position = marker.getPosition();

            var variables = {
                title: marker.vetPractice.title,
                companyType: marker.vetPractice.companyType_stringS,
                companyTypeId: marker.vetPractice.companyType_intS,
                street: marker.vetPractice.street_stringS,
                zip: marker.vetPractice.zip_stringS,
                city: marker.vetPractice.city_stringS,
                url: marker.vetPractice.url,
                isOpen: function () {
                    return isOpen(marker.vetPractice.openingHours_dateRangeM);
                }
            };

            var self = this;
            var $el = $(Mustache.render(template, variables, {}, ['<%', '%>']));
            $el.on('click', 'button', function () {
                self.setMap(null);
            });

            this.containerDiv = $el.get(0);

            // Optionally stop clicks, etc., from bubbling up to the map.
            google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
        }

        // ES5 magic to extend google.maps.OverlayView.
        Popup.prototype = Object.create(google.maps.OverlayView.prototype);

        /** Called when the popup is added to the map. */
        Popup.prototype.onAdd = function() {
            this.getPanes().floatPane.appendChild(this.containerDiv);
        };

        /** Called when the popup is removed from the map. */
        Popup.prototype.onRemove = function() {
            if (this.containerDiv.parentElement) {
              this.containerDiv.parentElement.removeChild(this.containerDiv);
            }
        };

        /** Called each frame when the popup needs to draw itself. */
        Popup.prototype.draw = function() {
            var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

            // Hide the popup when it is far out of view.
            var display =
                Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ?
                'block' :
                'none';

            if (display === 'block') {
                this.containerDiv.style.left = divPosition.x + 'px';
                this.containerDiv.style.top = divPosition.y + 'px';
            }
            if (this.containerDiv.style.display !== display) {
                this.containerDiv.style.display = display;
            }
        };

        return Popup;
    }

    var VetPracticeSearch = function(el, options)
    {
        this.el = el;
        this.$el = $(el).closest('.tx_solr');
        this.options = $.extend({}, this.defaults, $(el).data(), options);
        this.map = null;
        this.markerCluster = null;
        this.popup = null;
        this.image = null;
    };

    VetPracticeSearch.prototype.defaults = {
        assets: '',
        googlemapsapikey: '',
        initialLocation: {lat: 47.034047, lng: 8.183945},
        initialZoom: 9,
        jsontype: null,
        loadingClass: 'is-loading'
    }

    VetPracticeSearch.prototype.initialize = function(results, hasSearched)
    {
        window.dataLayer.push({
            'event': 'vet.initializeMap'
        });

        this.image = {
            url: this.options.assets + "img/Map/Marker.png",
            // This marker is 20 pixels wide by 32 pixels high.
            size: new google.maps.Size(49, 65),
            // The origin for this image is (0, 0).
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            anchor: new google.maps.Point(24, 65)
        };

        this.map = new google.maps.Map(
            document.getElementById('VetSearchResultMap'),
            {
                center: this.options.initialLocation,
                zoom: this.options.initialZoom,
                mapTypeId: 'roadmap',
                // maxZoom: 12
            }
        );

        this.markerCluster = new MarkerClusterer(this.map, [], {
            imagePath: this.options.assets + 'img/Map/cluster/m',
            imageSizes: [65]
        });

        var onSubmit = function (event) {
            event.preventDefault();
            var $form = $(event.target);
            var data = $form.serializeArray();
            data.push({name: 'type', value: this.options.type});
            data.push({name: 'record', value: this.options.record});
            this.search($form.attr('action'), data);
        };
        this.$el.on('submit', 'form', onSubmit.bind(this));

        var onChange = function(event){
            event.preventDefault();
            $(event.target).closest('form').submit();
        };
        this.$el.on('change', '[name$="[place]"]', onChange.bind(this));
        this.$el.on('change', '[name$="[distance]"]', onChange.bind(this));

        var handleFacets = function (event) {
            event.preventDefault();
            $('html').removeClass('facets-popup-open');
            var $el = $(event.target);
            var data = [];
            data.push({name: 'type', value: this.options.type});
            data.push({name: 'record', value: this.options.record});
            this.search($el.data('href'), data);
        };
        this.$el.on('click change', '.js-facets [data-href]', handleFacets.bind(this));

        if (results) {
            this._drawMap(results);
        }

        if (hasSearched) {
            this.map.setOptions({ maxZoom: 17 });
            this.markerCluster.fitMapToMarkers();
            this.map.setOptions({ maxZoom: 20 });
        }
    };

    VetPracticeSearch.prototype._drawMap = function (results)
    {

        window.dataLayer.push({
            'event': 'vet.drawMap'
        });

        if (this.popup) {
            this.popup.setMap(null);
        }

        this.markerCluster.clearMarkers();

        if (Array.isArray(results)) {
            results.forEach(this._addMarker.bind(this));
        }
    };

    VetPracticeSearch.prototype._addMarker = function (vetPractice)
    {
        try {
            var locationParts = vetPractice.site_location.split(',');
            var marker = new google.maps.Marker({
                position: {lat: parseFloat(locationParts[0]), lng: parseFloat(locationParts[1])},
                title: vetPractice.title,
                icon: this.image
            });
            marker.vetPractice = vetPractice;

            var popup = this.popup;
            var map = this.map;
            google.maps.event.addListener(marker, 'click', function () {
                if (popup) {
                    popup.setMap(null);
                }
                popup = new VetSearchResultPopup(this);
                map.setZoom(Math.max(14, map.getZoom()));
                map.panTo(marker.getPosition());
                popup.setMap(map);
            });

            this.markerCluster.addMarker(marker);
        } catch (e) {
            if (console) {
                console.warn(e, vetPractice);
            }
        }
    };

    VetPracticeSearch.prototype.search = function(url, data, pushHistory = true) {
        window.dataLayer.push({
            'event': 'vet.search'
        });

        this.$el.addClass(this.options.loadingClass);
        $('html').removeClass('facets-popup-open');

        var onBeforeSend = pushHistory ? function (jqXHR, settings) {
            try {
                var pushUrl = new URL(settings.url, window.location.origin);
                var params = new URLSearchParams(pushUrl.search);
                params.delete('type');
                params.delete('record');
                pushUrl.search = params.toString();
                history.pushState({url: url, data: data}, null, pushUrl.toString());
            } catch (e) {
                // Ignore
            }
        } : $.noop;

        $.ajax({
            url: url,
            data: data,
            beforeSend: onBeforeSend,
            context: this,
            success: function (response) {
                var $response = $(response);
                this.$el.removeClass(this.options.loadingClass);
                this.$el.find('.js-facets').html(
                    $response.find('.js-facets').html()
                );
                this.$el.find('.js-results').html(
                    ($response.find('.js-results').html() ? $response.find('.js-results').html() : "")
                );
                this.$el.find('.js-results-counter').html(
                    $response.find('.js-results-counter').html()
                );
                this.$el.find('.js-hidden-fields').html(
                    $response.find('.js-hidden-fields').html()
                );
            }
        });

        // Update map view
        data.push({name: 'type', value: this.options.jsontype});
        data.push({name: 'tx_solrgstsvs_vetpractice[format]', value: 'json'});

        $.ajax({
            url: url,
            data: data,
            context: this,
            success: function (response) {
                let results = response['searchResults'];
                this._drawMap(results);

                if (Array.isArray(results) && results.length) {
                    this.map.setOptions({ maxZoom: 17 });
                    this.markerCluster.fitMapToMarkers();
                    this.map.setOptions({ maxZoom: 20 });
                } else {
                    this.map.panTo(INITIAL_LOCATION);
                    this.map.setZoom(INITIAL_ZOOM);
                }
            }
        });
    };

    VetPracticeSearch.prototype.reset = function()
    {
        this.$el.find('[name$="[place]"]').val('');
        this.$el.find('[name$="[distance]"]').val('');
        this.$el.find('[name$="[q]"]').val('');
        this.search('', [], false);
    }

    var vetPracticeSearch = new VetPracticeSearch($('.js-vet-search').get(0));

    window.addEventListener('popstate', function(e) {
        if (e.state) {
            vetPracticeSearch.search(e.state.url, e.state.data, false);
            $.each(e.state.data, function (i, value){
                $('[name="'+value.name+'"]').val(value.value);
            });
        } else {
            vetPracticeSearch.reset();
        }
    });

    let ns = vetPracticeSearch.options.namespace;
    let initialSearchData = {};
    if (ns) {
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach(function(value, key) {
            if (key.startsWith(ns + '[') && key.endsWith(']')) {
                initialSearchData[key] = value;
            }
        });
    }

    $.when(
        $.post(vetPracticeSearch.options.json, initialSearchData),
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + vetPracticeSearch.options.googlemapsapikey)
    ).then(function (searchResponse) {
        VetSearchResultPopup = createPopupClass();
        var hasSearched = Object.keys(initialSearchData).length > 0;
        vetPracticeSearch.initialize(searchResponse[0]['searchResults'], hasSearched);
    }).fail(function (xhr, status, error) {
        document.getElementById('VetSearchResultMap').innerText = 'Error loading map: ' + error;
    });
}($));
